/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetAcceleratorRequest = {
  name: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

export type GetAcceleratorResponse =
  | components.ComputeAccelerator
  | components.ComputeErrorEnvelope;

/** @internal */
export const GetAcceleratorRequest$inboundSchema: z.ZodType<
  GetAcceleratorRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  name: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetAcceleratorRequest$Outbound = {
  name: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetAcceleratorRequest$outboundSchema: z.ZodType<
  GetAcceleratorRequest$Outbound,
  z.ZodTypeDef,
  GetAcceleratorRequest
> = z.object({
  name: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getAcceleratorRequestToJSON(
  getAcceleratorRequest: GetAcceleratorRequest,
): string {
  return JSON.stringify(
    GetAcceleratorRequest$outboundSchema.parse(getAcceleratorRequest),
  );
}
export function getAcceleratorRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetAcceleratorRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetAcceleratorRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetAcceleratorRequest' from JSON`,
  );
}

/** @internal */
export const GetAcceleratorResponse$inboundSchema: z.ZodType<
  GetAcceleratorResponse,
  z.ZodTypeDef,
  unknown
> = z.union([
  components.ComputeAccelerator$inboundSchema,
  components.ComputeErrorEnvelope$inboundSchema,
]);
/** @internal */
export type GetAcceleratorResponse$Outbound =
  | components.ComputeAccelerator$Outbound
  | components.ComputeErrorEnvelope$Outbound;

/** @internal */
export const GetAcceleratorResponse$outboundSchema: z.ZodType<
  GetAcceleratorResponse$Outbound,
  z.ZodTypeDef,
  GetAcceleratorResponse
> = z.union([
  components.ComputeAccelerator$outboundSchema,
  components.ComputeErrorEnvelope$outboundSchema,
]);

export function getAcceleratorResponseToJSON(
  getAcceleratorResponse: GetAcceleratorResponse,
): string {
  return JSON.stringify(
    GetAcceleratorResponse$outboundSchema.parse(getAcceleratorResponse),
  );
}
export function getAcceleratorResponseFromJSON(
  jsonString: string,
): SafeParseResult<GetAcceleratorResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetAcceleratorResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetAcceleratorResponse' from JSON`,
  );
}
